import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAssets = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "DocumentType",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Assets",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Vector",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M2.8667 6.7467V14.6801H6.60003V10.9468C6.60003 10.6992 6.69837 10.4619 6.8734 10.2868C7.04843 10.1118 7.28583 10.0134 7.53337 10.0134H8.4667C8.71423 10.0134 8.95163 10.1118 9.12667 10.2868C9.3017 10.4619 9.40003 10.6992 9.40003 10.9468V14.6801H13.1334V7.13527",
						fill: "#F5ECE7"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M1 8.6134L7.33982 2.27358C7.4265 2.18685 7.52941 2.11804 7.64269 2.0711C7.75597 2.02416 7.87738 2 8 2C8.12262 2 8.24403 2.02416 8.35731 2.0711C8.47059 2.11804 8.5735 2.18685 8.66018 2.27358L15 8.6134",
						fill: "#F5ECE7"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M2.8667 6.7467V14.6801H6.60003V10.9468C6.60003 10.6992 6.69837 10.4619 6.8734 10.2868C7.04843 10.1118 7.28583 10.0134 7.53337 10.0134H8.4667C8.71423 10.0134 8.95163 10.1118 9.12667 10.2868C9.3017 10.4619 9.40003 10.6992 9.40003 10.9468V14.6801H13.1334V7.13527M1 8.6134L7.33982 2.27358C7.4265 2.18685 7.52941 2.11804 7.64269 2.0711C7.75597 2.02416 7.87738 2 8 2C8.12262 2 8.24403 2.02416 8.35731 2.0711C8.47059 2.11804 8.5735 2.18685 8.66018 2.27358L15 8.6134",
						stroke: "#D5B29F",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					})
				]
			})
		})
	})
});
export default SvgAssets;
